/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Value_Practice_TitleInputs */



/**
* | output |
* | --- |
* | "Practice conversations and coaching" |
*
* @param {Onboarding_Value_Practice_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_value_practice_title = /** @type {((inputs?: Onboarding_Value_Practice_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Value_Practice_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Oefengesprekken en coaching")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conversations d’entraînement et coaching")
	return /** @type {LocalizedString} */ ("Practice conversations and coaching")
});